import React, { useEffect, useState } from 'react';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';
import { IData } from '~/src/features/videocontrol/pageBlocks/Advantages/types';

import { customDotsStyles } from '~/src/features/videocontrol/styled';
import * as ST from './styled';

const sDesktopSize = `(max-width: ${wideBreakpoints.sDesktop})`;
const laptopSize = `(max-width: ${wideBreakpoints.laptop})`;
const tabletSize = `(max-width: ${wideBreakpoints.tablet})`;
const mobileSize = `(max-width: ${wideBreakpoints.mobile})`;

interface IProps {
    incomingData: IData[],
}

const AdvantagesBlock = ({ incomingData }: IProps): JSX.Element => {

    const [onClientSide, setOnClientSide] = useState(isClientSide());

    const isLaptop = useMatchMedia(laptopSize);
    const isSDesktop = useMatchMedia(sDesktopSize);
    const isTablet = useMatchMedia(tabletSize);
    const isMobile = useMatchMedia(mobileSize);

    useEffect(() => {
        setOnClientSide(isClientSide);
    }, []);

    const renderTabletChildren = () => {
        return (
            <ST.ListWrap>
                {incomingData[0].id === 1 &&
                    <ST.SRow>
                        <ST.SCol>
                            <ST.Card isHigher={incomingData[0].isHigher}>
                                <ST.ImageWrap
                                    pngImg={incomingData[0].bgImageM}
                                    webpImg={incomingData[0].bgImageMWebp}
                                >
                                    <ST.DescriptionWrap>
                                        <ST.Title>{incomingData[0].question}</ST.Title>
                                        <ST.Text>{incomingData[0].answer}</ST.Text>
                                    </ST.DescriptionWrap>
                                </ST.ImageWrap>
                            </ST.Card>
                        </ST.SCol>
                    </ST.SRow>
                }
                <ST.SRow>
                    {incomingData.map((elem) => {
                        const {
                            id,
                            question,
                            answer,
                            bgImageM,
                            bgImageMWebp,
                        } = elem;
                        if (id <= 1 || id >= 4) {
                            return null;
                        }

                        return (
                            <ST.SCol key={id}>
                                <ST.Card>
                                    <ST.ImageWrap
                                        pngImg={bgImageM}
                                        webpImg={bgImageMWebp}
                                        isContain={id === 3}
                                    >
                                        <ST.DescriptionWrap>
                                            <ST.Title>{question}</ST.Title>
                                            <ST.Text>{answer}</ST.Text>
                                        </ST.DescriptionWrap>
                                    </ST.ImageWrap>
                                </ST.Card>
                            </ST.SCol>
                        );
                    })}
                </ST.SRow>
                <ST.SRow style={{ flexDirection: 'row-reverse' }}>
                    {incomingData.map((elem) => {
                        const {
                            id,
                            question,
                            answer,
                            bgImageM,
                            bgImageMWebp,
                        } = elem;
                        if (id <= 3) {
                            return null;
                        }

                        return (
                            <ST.SCol key={id}>
                                <ST.Card>
                                    <ST.ImageWrap
                                        pngImg={bgImageM}
                                        webpImg={bgImageMWebp}
                                        isContain={id === 5}
                                    >
                                        <ST.DescriptionWrap isTopText={id === 4}>
                                            <ST.Title>{question}</ST.Title>
                                            <ST.Text>{answer}</ST.Text>
                                        </ST.DescriptionWrap>
                                    </ST.ImageWrap>
                                </ST.Card>
                            </ST.SCol>
                        );
                    })}
                </ST.SRow>
            </ST.ListWrap>
        );
    };

    const renderChildren = () => {
        return (
            <ST.ListWrap>
                <ST.SRow>
                    {incomingData.map((elem) => {
                        const {
                            id,
                            question,
                            answer,
                            bgImageXXL,
                            bgImageXL,
                            bgImageL,
                            bgImageXXLWebp,
                            bgImageXLWebp,
                            bgImageLWebp,
                            isLaptopImage,
                            isHigher,
                        } = elem;
                        if (id > 2) {
                            return null;
                        }

                        return (
                            <ST.SCol key={id}>
                                <ST.Card isHigher={isHigher}>
                                    <ST.ImageWrap
                                        pngImg={isLaptop ? bgImageL : isSDesktop ? bgImageXL : bgImageXXL}
                                        webpImg={isLaptop ? bgImageLWebp : isSDesktop ? bgImageXLWebp : bgImageXXLWebp}
                                    >
                                        <ST.DescriptionWrap isLaptopImage={isLaptopImage}>
                                            <ST.Title>{question}</ST.Title>
                                            <ST.Text>{answer}</ST.Text>
                                        </ST.DescriptionWrap>
                                    </ST.ImageWrap>
                                </ST.Card>
                            </ST.SCol>
                        );
                    })}
                </ST.SRow>
                <ST.SRow>
                    {incomingData.map((elem) => {
                        const {
                            id,
                            question,
                            answer,
                            bgImageXXL,
                            bgImageXL,
                            bgImageL,
                            bgImageXXLWebp,
                            bgImageXLWebp,
                            bgImageLWebp,
                            isLaptopImage,
                        } = elem;
                        if (id <= 2) {
                            return null;
                        }

                        return (
                            <ST.SCol key={id}>
                                <ST.Card>
                                    <ST.ImageWrap
                                        pngImg={isLaptop ? bgImageL : isSDesktop ? bgImageXL : bgImageXXL}
                                        webpImg={isLaptop ? bgImageLWebp : isSDesktop ? bgImageXLWebp : bgImageXXLWebp}
                                        isContain={id === 3 || id === 5}>
                                        <ST.DescriptionWrap
                                            isTopText={id === 4}
                                            isLaptopImage={isLaptopImage}
                                        >
                                            <ST.Title>{question}</ST.Title>
                                            <ST.Text>{answer}</ST.Text>
                                        </ST.DescriptionWrap>
                                    </ST.ImageWrap>
                                </ST.Card>
                            </ST.SCol>
                        );
                    })}
                </ST.SRow>
            </ST.ListWrap>
        );
    };

    return (
        onClientSide && isMobile
            ? <AdaptiveNukaCarousel
                withoutArrows
                desktopSlideWidth={'320px'}
                cellSpacing={32}
                slidesToScroll={'auto'}
                customDotsStyles={customDotsStyles}
                visibleSlides={{
                    desktop: 4,
                    sDesktop: 3,
                    laptop: 2,
                    mobile: 1,
                }}
                wrapAround={false}
            >
                {incomingData.map((elem) => {
                    const {
                        id,
                        question,
                        answer,
                        bgImageS,
                        bgImageSWebp,
                    } = elem;
                    return (
                        <ST.SCol key={id}>
                            <ST.Card>
                                <ST.ImageWrap
                                    pngImg={bgImageS}
                                    webpImg={bgImageSWebp}
                                    isContain={id === 1 || id === 3 || id === 5}>
                                    <ST.DescriptionWrap
                                        isTopText={id === 4}
                                        isMobileImage={id === 2}
                                    >
                                        <ST.Title>{question}</ST.Title>
                                        <ST.Text>{answer}</ST.Text>
                                    </ST.DescriptionWrap>
                                </ST.ImageWrap>
                            </ST.Card>
                        </ST.SCol>
                    );
                })}
            </AdaptiveNukaCarousel>
            : onClientSide && isTablet
                ? <ST.NoSsrContainer>
                    {renderTabletChildren()}
                </ST.NoSsrContainer>
                : <ST.NoSsrContainer>
                    {renderChildren()}
                </ST.NoSsrContainer>
    );
};

export default AdvantagesBlock;
